<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Print Template</v-toolbar-title>

		    <!-- <v-spacer></v-spacer>

		    <v-btn round-borders outline @click="fn_checkValidations">save</v-btn> -->

		    <!-- <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn> -->
		</v-toolbar>

		<v-form class="form-element hasToolbar hasFooter grey-back">

			<v-layout wrap class="form_wrapper">

				<v-layout wrap padding-top-ten white-background>
					<v-flex xs12 sm12 md12 form-item>
		               <v-text-field  v-model="Form.name" label="Name" placeholder=" " v-validate="'required'" :error-messages="errors.collect('name')" data-vv-name="name" required></v-text-field>
		            </v-flex>
				</v-layout>

				<v-layout wrap white-background margin-top-ten>
					<v-subheader full-width border-bottom-thin>Print Type</v-subheader>
				  	<v-flex xs12 sm12 md12 form-item>
			           	<v-radio-group row v-model="Form.templateType" @change="fn_hideSection">
			            	<v-radio label="Sale/Purchase" :value="0"></v-radio>
			            	<v-radio label="Account Book" :value="1"></v-radio>
			            	<!-- <v-radio label="Stock Journal" :value="2"></v-radio> -->
			            </v-radio-group>
			        </v-flex>
				</v-layout>

				<v-layout wrap white-background margin-top-ten v-if="!Form.templateType">
					<v-subheader full-width border-bottom-thin>Theme</v-subheader>

					<v-flex xs12 sm12 md12 form-item mt-3 @click="fn_openInvoiceTemplates">
		               <v-text-field  
			               	readonly
			               	:value="fn_getTemplateName()"
			               	label="Invoice Template"
			               	placeholder=" " 
			               	append-icon="arrow_drop_down">
		               </v-text-field>
		            </v-flex>

		            <v-flex xs12 sm12 md12 form-item @click="fn_openThemeColors">
		            	<div style="width:40px;height:40px;float:left;margin:6px 16px 0px 0px" :style="{'background':Form.themeColor}"></div>
		               <v-text-field  
			               	readonly
			               	:value="fn_getThemeColorName()"
			               	label="Theme Color"
			               	placeholder=" " 
			               	append-icon="arrow_drop_down">
		               </v-text-field>
		            </v-flex>

		           <!--  <v-flex xs12 sm12 md12 form-item @click="fn_openRowColors" v-if="Form.alternateRowColor">
		            	<div style="width:40px;height:40px;float:left;margin:6px 16px 0px 0px" :style="{'background':Form.tableRowColor}"></div>
		               <v-text-field  
			               	readonly
			               	:value="fn_getRowColorName()"
			               	label="Table Row Color"
			               	placeholder=" " 
			               	append-icon="arrow_drop_down">
		               </v-text-field>
		            </v-flex> -->

		            <!-- <v-flex xs12 sm12 md12 form-item>
		               <v-checkbox right-align-checkbox label="Table Alternate Row Color" v-model="Form.alternateRowColor"></v-checkbox>
		            </v-flex> -->

		            <v-flex xs12 sm12 md12 form-item>
		               <v-checkbox right-align-checkbox label="Table Row Border" v-model="Form.tableRowBorder"></v-checkbox>
		            </v-flex>

		           

		            
				  	<!-- <v-flex xs12 sm12 md12 form-item>
			           	<v-radio-group row v-model="Form.theme">
			            	<v-radio label="Light" value="theme_light"></v-radio>
			            	<v-radio label="Basic" value="theme_basic"></v-radio>
			            	<v-radio label="Dark" value="theme_dark"></v-radio>
			            </v-radio-group>
			        </v-flex> -->
				</v-layout>

				<v-layout wrap margin-top-ten white-background>
		            <v-flex xs12 sm12 md12 form-item>
		               <v-checkbox right-align-checkbox label="Business Logo" v-model="Form.businessLogo"></v-checkbox>
		            </v-flex>
				</v-layout>

				<!-- <photoshop-picker v-model="colors"></photoshop-picker> -->

				<!-- <chrome-picker v-model="colors" :value="colors" @input="updateValue"></chrome-picker> -->

				<!-- <sketch-picker v-model="colors"></sketch-picker> -->

				<!-- <v-layout wrap white-background margin-top-ten v-if="!Form.templateType">
					<v-subheader full-width border-bottom-thin>Party Address Labels</v-subheader>
					
					<v-layout row wrap padding-top-ten>

						<v-flex xs6 sm6 md6 pl-3 pr-2>
			               <v-text-field  
				               	v-model="Form.billingLabel" 
				               	label="Billing"
				               	placeholder=" " 
				               	v-validate="'required'" 
			               		data-vv-name="billingLabel" 
			               		data-vv-as="billing label" 
			               		:error-messages="errors.collect('billingLabel')"
			               		required>
			               </v-text-field>
			            </v-flex>

			            <v-flex xs6 sm6 md6 pr-3 pl-2>
			               <v-text-field  
				               	v-model="Form.shippingLabel" 
				               	label="Shipping"
				               	placeholder=" " 
				               	v-validate="'required'" 
			               		data-vv-name="shippingLabel" 
			               		data-vv-as="shipping label" 
			               		:error-messages="errors.collect('shippingLabel')"
			               		required>
			               </v-text-field>
			            </v-flex>

					</v-layout>
					
				</v-layout> -->

				<v-layout wrap white-background margin-top-ten>
					<v-subheader full-width border-bottom-thin>Print Sections</v-subheader>
					
					<v-layout row wrap padding-top-ten>

						<v-flex xs12 sm12 md12 form-item v-for="(item, index) in Form.printTemplateSections" :key="index" @click="fn_openDialogPrintFields(item)" v-if="!item.isHidden">
			               <v-text-field  
				               	readonly
				               	v-model="item.fieldName" 
				               	:label="fn_getlabel(item.sectionName)"
				               	placeholder=" " 
				               	append-icon="arrow_drop_down"
				               	v-validate="item.isRequired ? 'required' : ''" 
			               		:data-vv-name="item.sectionName" 
			               		:data-vv-as="fn_getlabel(item.sectionName)" 
			               		:error-messages="errors.collect(item.sectionName)"
			               		required>
			               </v-text-field>
			            </v-flex>

					</v-layout>

				</v-layout>

			</v-layout>
				
			<v-list subheader nopadding margin-top-ten class="fields" v-if="!Form.templateType">
				<v-subheader>Fields
					<v-spacer></v-spacer>
					<v-btn flat small color="primary" justify-content-to-end nomargin :ripple="false" @click="fn_openDialogFields">Add</v-btn>

					<v-menu v-if="Form.printTemplateFields.length>1">
					  <v-btn icon slot="activator" justify-content-to-end nomargin :ripple="false"><v-icon>more_vert</v-icon></v-btn>
					  <v-list nopadding>
					    <v-list-tile @click="fn_openDialogReorder">
					      <v-list-tile-title>Re-order</v-list-tile-title>
					    </v-list-tile>
					  </v-list>
					</v-menu>
				</v-subheader>

				<v-divider></v-divider>

				<div v-for="(item, index) in Form.printTemplateFields" :key="index">
					<v-list-tile :id="'field'+(index+1)">
						<v-list-tile-content>
							<v-list-tile-title>{{item.name}}</v-list-tile-title>
						</v-list-tile-content>

						<v-list-tile-action>
							<v-menu>
							  <v-btn icon slot="activator"><v-icon>more_vert</v-icon></v-btn>
							  <v-list nopadding>
							    <v-list-tile @click="fn_removeField(index)">
							      <v-list-tile-title>Remove</v-list-tile-title>
							    </v-list-tile>
							  </v-list>
							</v-menu>
						</v-list-tile-action>
					</v-list-tile>

					<v-divider v-if="Form.printTemplateFields.length-1 != index"></v-divider>
				</div>
			</v-list>

			<div style="position:fixed;bottom:0" full-width>
				<v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Save</v-btn>
			</div>

		</v-form>

		<!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>
	    <dialog-fields ref="ref_dialogFields" :addField="fn_addField"></dialog-fields>
	    <dialog-reorder ref="ref_dialogReorder"></dialog-reorder>
	    <dialog-print-fields ref="ref_dialogPrintFields" :setFieldValue="fn_setFieldValue" :removePrintField="fn_removePrintField"></dialog-print-fields>
	    <dialog-invoice-template ref="ref_dialogInvoiceTemplate" :items="Form.invoiceTemplates" :updateInvoiceTemplate="fn_updateInvoiceTemplate"></dialog-invoice-template>

	    <dialog-theme-color ref="ref_dialogThemeColor" :items="Form.themeColors" :updateThemeColor="fn_updateThemeColor" :openColorPicker="fn_openColorPicker"></dialog-theme-color>

	    <!-- <dialog-row-color ref="ref_dialogRowColor" :items="Form.rowColors" :updateRowColor="fn_updateRowColor" :openColorPicker="fn_openColorPicker"></dialog-row-color> -->

	    <dialog-color-picker ref="ref_dialogColorPicker"></dialog-color-picker>

	</div>
</template>

<script>
const menuItem = require('../../config.js').configs.menuItem;
const dialogjs =  require('../masters/forms/dialog').dialogjs;

import dialogDiscard from '../dialogs/dialog_discard'
import dialogFields from './dialogs/dialog_fields'
import dialogReorder from './dialogs/dialog_reorder'
import dialogPrintFields from './dialogs/dialog_print_fields'
import dialogInvoiceTemplate from './dialogs/dialog_invoice_template'
import dialogThemeColor from './dialogs/dialog_theme_color'
// import dialogRowColor from './dialogs/dialog_row_color'
import dialogColorPicker from './dialogs/dialog_color_picker'

	export default{
		data(){
			return{
				Form:{
					"printTemplateId":null, 
					"name":null, 
					"templateType":0,
					"businessLogo":true, 
					// "billingLabel":null,
					// "shippingLabel":null,
					"theme":"theme_light", 
					"printTemplateSections":[
						{"printSectionId":this.guid(), "sectionName":"header", "fieldId":null, "fieldName":null, "isHidden":false, "isRequired":false},
						{"printSectionId":this.guid(), "sectionName":"terms", "fieldId":null, "fieldName":null, "isHidden":false, "isRequired":false},
						{"printSectionId":this.guid(), "sectionName":"bankDetails", "fieldId":null, "fieldName":null, "isHidden":false, "isRequired":false},
						{"printSectionId":this.guid(), "sectionName":"signature", "fieldId":null, "fieldName":null, "isHidden":false, "isRequired":false},
						{"printSectionId":this.guid(), "sectionName":"subtitle", "fieldId":null, "fieldName":null, "isHidden":false, "isRequired":false},
						{"printSectionId":this.guid(), "sectionName":"billingLabel", "fieldId":null, "fieldName":null, "isHidden":false, "isRequired":false},
						{"printSectionId":this.guid(), "sectionName":"shippingLabel", "fieldId":null, "fieldName":null, "isHidden":false, "isRequired":false}
					],
					"selectedField":null,
					"activeSectionName":null,
					"printTemplateFields":[],
					"invoiceTemplates":[
						{"id":1, "name":"Template 1"},
						{"id":2, "name":"Template 2"},
						{"id":3, "name":"Template 3"},
						{"id":4, "name":"Template 4"},
						{"id":5, "name":"Template 5"}
					],
					// "themeColors":[
					// 	{"id":1, "name":"Slate Grey", "colorCode":"lightgrey"},
					// 	{"id":2, "name":"Light Blue", "colorCode":"lightblue"},
					// 	{"id":3, "name":"Teal", "colorCode":"teal"},
					// 	{"id":4, "name":"Cold Green", "colorCode":"lightgreen"},
					// 	{"id":5, "name":"Sky Blue", "colorCode":"lightskyblue"},
					// 	{"id":6, "name":"Rose Pink", "colorCode":"lightpink"}
					// ],
					"themeColors":[
						{"id":1, "name":"App Blue", "colorCode":"rgba(75, 119, 190,0.4)"},
						{"id":2, "name":"Light Grey", "colorCode":"rgba(211,211,211,0.4)"},
						{"id":3, "name":"Dark Grey", "colorCode":"rgba(128,128,128,0.4)"},
						{"id":4, "name":"Teal", "colorCode":"rgba(0,128,128,0.4)"},
						{"id":5, "name":"Light Blue", "colorCode":"rgba(173,216,230,0.4)"},
						{"id":6, "name":"Cold Green", "colorCode":"rgba(144,238,144,0.4)"},
						{"id":7, "name":"Sky Blue", "colorCode":"rgba(135,206,250,0.4)"},
						{"id":8, "name":"Rose Pink", "colorCode":"rgba((255,182,193,0.4))"}
					],
					// "rowColors":[
					// 	{"id":1, "name":"Ghost White", "colorCode":"ghostwhite"},
					// 	{"id":2, "name":"Light Grey", "colorCode":"lightgrey"},
					// 	{"id":5, "name":"Light Blue", "colorCode":"lightblue"},
					// 	{"id":3, "name":"Azure", "colorCode":"azure"},
					// 	{"id":4, "name":"Cyan", "colorCode":"lightcyan"},
					// ],
					"invoiceTemplate":1,
					"themeColor":"teal",
					// "tableRowColor":"ghostwhite",
					"tableRowBorder":true,
					// "alternateRowColor":true,

					"colorPickerType":null,
					"customThemeColor":true,
					// "customRowColor":false
				},
				loading:false,
				backButtonPress: false,
				dialogStorageId:null,
				discardChanges:false,
			}
		},
		components:{
			'dialog-discard': dialogDiscard,
			'dialog-fields': dialogFields,
			'dialog-reorder': dialogReorder,
			'dialog-print-fields': dialogPrintFields,
			'dialog-invoice-template':dialogInvoiceTemplate,
			'dialog-theme-color':dialogThemeColor,
			// 'dialog-row-color':dialogRowColor,
			'dialog-color-picker':dialogColorPicker
		},
		methods:{
			fn_openColorPicker: function(type){
				this.fn_closeDialog();
				this.Form.colorPickerType = type;
				let self = this;
				setTimeout(function(){
					self.fn_openDialogWeb('web', 'ColorPicker', 'ref_dialogColorPicker');
				},300)
				
			},

			fn_openThemeColors: function(){
				this.fn_openDialogWeb('web', 'ThemeColor', 'ref_dialogThemeColor');
			},

			// fn_openRowColors: function(){
			// 	this.fn_openDialogWeb('web', 'RowColor', 'ref_dialogRowColor');
			// },

			fn_openInvoiceTemplates: function(){
				this.fn_openDialogWeb('web', 'InvoiceTemplate', 'ref_dialogInvoiceTemplate');
			},

			fn_updateInvoiceTemplate: function(item){
				this.Form.invoiceTemplate = item.id;
				this.fn_closeDialog();
			},

			fn_updateThemeColor: function(item){
				this.Form.themeColor = item.colorCode;
				this.fn_closeDialog();
			},

			// fn_updateRowColor: function(item){
			// 	this.Form.tableRowColor = item.colorCode;
			// 	this.fn_closeDialog();
			// },

			fn_getThemeColorName: function(){
				let themeColorName = null;
				this.Form.customThemeColor = true;
				let colorCode = null;
				for(let i=0; i<this.Form.themeColors.length; i++){
					if(this.Form.themeColors[i].colorCode == this.Form.themeColor){
						themeColorName = this.Form.themeColors[i].name;
						colorCode = this.Form.themeColor;
						this.Form.customThemeColor = false;
						break;
					}
				}

				if(colorCode)
					return themeColorName;
				else
					return this.Form.themeColor;
			},

			// fn_getRowColorName: function(){
			// 	let rowColorName = null;
			// 	this.Form.customRowColor = true;
			// 	let colorCode = null;
			// 	for(let i=0; i<this.Form.rowColors.length; i++){
			// 		if(this.Form.rowColors[i].colorCode == this.Form.tableRowColor){
			// 			rowColorName = this.Form.rowColors[i].name;
			// 			colorCode = this.Form.tableRowColor;
			// 			this.Form.customRowColor = false;
			// 			break;
			// 		}
			// 	}
			// 	// return rowColorName;
			// 	if(colorCode)
			// 		return rowColorName;
			// 	else
			// 		return this.Form.tableRowColor;
			// },

			fn_getTemplateName: function(){
				let templateName = null;
				for(let i=0; i<this.Form.invoiceTemplates.length; i++){
					if(this.Form.invoiceTemplates[i].id == this.Form.invoiceTemplate){
						templateName = this.Form.invoiceTemplates[i].name;
						break;
					}
				}
				return templateName;
			},

			fn_getlabel: function(sectionName){
				if(sectionName == 'header')
					return 'Header'
				else if(sectionName == 'terms')
					return 'Terms & Conditions'
				else if(sectionName == 'bankDetails')
					return 'Bank Details'
				else if(sectionName == 'signature')
					return 'Authorised Signatory'
				else if(sectionName == 'subtitle')
					return 'Sub Title'
				else if(sectionName == 'billingLabel')
					return 'Billing Label'
				else if(sectionName == 'shippingLabel')
					return 'Shipping Label'
			},

			fn_hideSection: function(){
				for(let i=0;i<this.Form.printTemplateSections.length;i++){
					if(!this.Form.templateType){
						this.Form.printTemplateSections[i].isHidden = false;
					}
					else if(this.Form.printTemplateSections[i].sectionName=='header' || this.Form.printTemplateSections[i].sectionName=='signature'){
						this.Form.printTemplateSections[i].isHidden = false;
					}
					else{
						this.Form.printTemplateSections[i].isHidden = true;
					}
				}
			},

			fn_addField: function(item){

				let itemIndex = this.Form.printTemplateFields.findIndex(field=>{
					return item.fieldId == field.fieldId;
				});

				if(itemIndex!=-1){
					this.showToast("Already Exists");
					return;
				}
				else{
					this.fn_closeDialog();
					let obj = {};
					obj.printTemplateFieldId = this.guid();
					obj.fieldId = item.fieldId;
					obj.name = item.name;
					this.Form.printTemplateFields.push(obj);
					let self = this;
					setTimeout(function(){
						self.$vuetify.goTo('#field'+self.Form.printTemplateFields.length, self.scrollOptions);
					})
				}
			},

			fn_saveOrder: function(fields){
				this.Form.printTemplateFields = JSON.parse(JSON.stringify(fields));
				this.fn_closeDialog();
				this.$vuetify.goTo('.fields', self.scrollOptions);
			},

			fn_openDialogReorder: function(){
				this.fn_openDialogWeb('web', 'ReorderField', 'ref_dialogReorder');
			},

			fn_removeField: function(index){
				this.Form.printTemplateFields.splice(index, 1);
			},

			fn_openDialogFields: function(){
				this.fn_openDialogWeb('web', 'Fields', 'ref_dialogFields');
			},

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard');
			},

			fn_openDialogPrintFields: function(field){
				this.Form.selectedField = field.fieldName;
				this.Form.activeSectionName = field.sectionName;
				this.fn_openDialogWeb('web', 'PrintFields', 'ref_dialogPrintFields');
			},

			fn_setFieldValue: function(item){
				for(let i=0; i<this.Form.printTemplateSections.length; i++){
					if(this.Form.activeSectionName == this.Form.printTemplateSections[i].sectionName){
						this.Form.printTemplateSections[i].fieldId = item.fieldId;
						this.Form.printTemplateSections[i].fieldName = item.name;
					}
				}

				this.fn_closeDialog();
			},

			fn_removePrintField: function(){
				this.fn_closeDialog();
				for(let i=0; i<this.Form.printTemplateSections.length; i++){
					if(this.Form.printTemplateSections[i].sectionName == this.Form.activeSectionName){
						this.Form.printTemplateSections[i].fieldId = null;
						this.Form.printTemplateSections[i].fieldName = null;
						this.Form.selectedField = null;
						break;
					}
				}
			},

			fn_draftAction: function(){
				this.fn_closeDialog()
				this.discardChanges = true;
				this.fn_goBack();
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialog: function(){
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			// fn_getBottomMenu: function (tagId) {
			// 	var bottomMenu = {"BottomMenu": [menuItem.save, menuItem.reset, menuItem.help]};
			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_checkValidations: function(){
				var self = this;
			    this.$validator.validateAll().then((result) => {
			        if (result) {
			        	this.fn_post()
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			        self.loading = false;
			    });
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('PrintTemplate', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				          let status = JSON.parse(response);
				          if(status) {
				          	self.fn_cleanUp();
				          }
				          else {
				          	self.showToast("Already exists with this name");
				          }
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_get: function(itemId){
				var self = this;
				this.getData('PrintTemplate', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);
							self.fn_bindData(data);
							if(self.Form.templateType){
								self.fn_hideSection();
							}
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_bindData: function(data){
				this.Form.printTemplateFields = data.printTemplateFields;
				this.Form.printTemplateSections = data.printTemplateSections;
				this.Form.businessLogo = data.businessLogo;
				this.Form.isHidden = data.isHidden;
				this.Form.name = data.name;
				this.Form.printTemplateId = data.printTemplateId;
				this.Form.templateType = data.templateType;
				this.Form.terms = data.terms;
				// this.Form.tableRowColor = data.tableRowColor;
				this.Form.invoiceTemplate = data.invoiceTemplate;
				this.Form.themeColor = data.themeColor;
				// this.Form.alternateRowColor = data.alternateRowColor;
				this.Form.tableRowBorder = data.tableRowBorder;
			},

			fn_cleanUp: function () {
				if(this.$route.query.ls){
					let data = {};
					data.type = 'printTemplate';
					data.id = this.Form.printTemplateId;
					data.name = this.Form.name;
					localStorage.setItem('newItem', JSON.stringify(data));
					localStorage.setItem('closeDialog', 1);
				}

				this.discardChanges = true;
	          	this.$router.go(-1);
			},

			fn_post: function(){
				!this.Form.printTemplateId ? this.Form.printTemplateId = this.guid() : '';
				this.Form.name = this.Form.name.trim();
				console.log(this.Form);

				for(let i=0;i<this.Form.printTemplateFields.length;i++){
					this.Form.printTemplateFields[i].orderNumber = i+1;
				}

				this.fn_saveLocal(this.Form);
			},

			fn_clearForm: function(){
				this.Form = {	
								"printTemplateId":null, 
								"name":null, 
								"templateType":0,
								"businessLogo":true, 
								// "billingLabel":null,
								// "shippingLabel":null,
								"theme":'light', 
								"printTemplateSections":[
									{"printSectionId":this.guid(), "sectionName":"terms", "fieldId":null, "fieldName":null, "isRequired":true},
									{"printSectionId":this.guid(), "sectionName":"header", "fieldId":null, "fieldName":null, "isRequired":false},
									{"printSectionId":this.guid(), "sectionName":"bankDetails", "fieldId":null, "fieldName":null, "isRequired":false},
									{"printSectionId":this.guid(), "sectionName":"signature", "fieldId":null, "fieldName":null, "isRequired":false},
									{"printSectionId":this.guid(), "sectionName":"subtitle", "fieldId":null, "fieldName":null, "isHidden":false, "isRequired":false},
									{"printSectionId":this.guid(), "sectionName":"billingLabel", "fieldId":null, "fieldName":null, "isHidden":false, "isRequired":false},
									{"printSectionId":this.guid(), "sectionName":"shippingLabel", "fieldId":null, "fieldName":null, "isHidden":false, "isRequired":false}
								],
								"selectedField":null,
								"activeSectionName":null,
								"printTemplateFields":[]
							};
				this.$validator.reset();
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use

				this.backButtonPress = false;
				
				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
			},

			fn_resetForm: function () {
				this.fn_clearForm();
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){
			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			window.js_globals.fn_onBackPress = this.fn_goBack;
			// window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;

			this.fn_showWebView();
		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {

		  		let itemId = null;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
					itemId = from.params.tagId;
				}

				//edit from list view
		  		else if(from.name=='printTemplateItems' && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		if(itemId){
		  			vm.fn_get(itemId);
		  		}
		  	})
		},
	    beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
					next(false);
				}
				else{
					next(true);
				}
			}
			else{
				if(!this.discardChanges){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					next();	
				}
				
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/print_templates/form.vue